import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
	LandingPage,
	Header,
	Home,
	ScrollToTop,
	Membership,
	Locations,
	OurMission,
	AllGear,
	MenGear,
	WomenGear,
	MenTankTop,
	MenNikeDFLongSleeve,
	MenNikeDFShirt,
	MenNikePulloverHoodie,
	MenNikeFullZipSweatshirt,
	NikeTwillHat,
	MenAdidasPerformanceShirt,
	MenAdidasLongSleeve,
	AdidasPerformanceHat,
	MenUAShirt,
	MenUALongSleeve,
	MenUAZipPullover,
	UAPerformanceHat,
	WomensTankTop,
	WomensNikeDFShirt,
	WomensNikeDFLongSleeve,
	WomensNikePulloverHoodie,
	WomensNikeFullZipSweatshirt,
	WomensAdidasPerformanceShirt,
	WomensAdidasLongSleeve,
	WomensAdidasPolo,
	WomensUAShirt,
	WomensUALongSleeve,
	WomensUAZipPullover,
	Footer
} from './index';
import './globalStyles.css';
import product from './pages/gear/all-gear/all-gear.json';

const App = () => {
	return (
		<Router>
			<Switch>
				<Route exact path="/" component={LandingPage} />
				<React.Fragment>
					<Header />
					<Route exact path="/home" component={Home} />
					<Route exact path="/membership" component={Membership} />
					<Route exact path="/locations" component={Locations} />
					<Route exact path="/our-mission" component={OurMission} />
					<Route exact path="/all-gear" component={AllGear} />
					<Route exact path="/men-gear" component={MenGear} />
					<Route exact path="/women-gear" component={WomenGear} />
					<Route exact path={product.allGear[0].url} component={MenTankTop} />
					<Route exact path={product.allGear[1].url} component={MenNikeDFShirt} />
					<Route exact path={product.allGear[2].url} component={MenNikeDFLongSleeve} />
					<Route exact path={product.allGear[3].url} component={MenNikePulloverHoodie} />
					<Route exact path={product.allGear[4].url} component={MenNikeFullZipSweatshirt} />
					<Route exact path={product.allGear[5].url} component={NikeTwillHat} />
					<Route exact path={product.allGear[6].url} component={MenAdidasPerformanceShirt} />
					<Route exact path={product.allGear[7].url} component={MenAdidasLongSleeve} />
					<Route exact path={product.allGear[8].url} component={AdidasPerformanceHat} />
					<Route exact path={product.allGear[9].url} component={MenUAShirt} />
					<Route exact path={product.allGear[10].url} component={MenUALongSleeve} />
					<Route exact path={product.allGear[11].url} component={MenUAZipPullover} />
					<Route exact path={product.allGear[12].url} component={UAPerformanceHat} />
					<Route exact path={product.allGear[13].url} component={WomensTankTop} />
					<Route exact path={product.allGear[14].url} component={WomensNikeDFShirt} />
					<Route exact path={product.allGear[15].url} component={WomensNikeDFLongSleeve} />
					<Route exact path={product.allGear[16].url} component={WomensNikePulloverHoodie} />
					<Route exact path={product.allGear[17].url} component={WomensNikeFullZipSweatshirt} />
					<Route exact path={product.allGear[18].url} component={WomensAdidasPerformanceShirt} />
					<Route exact path={product.allGear[19].url} component={WomensAdidasLongSleeve} />
					<Route exact path={product.allGear[20].url} component={WomensAdidasPolo} />
					<Route exact path={product.allGear[21].url} component={WomensUAShirt} />
					<Route exact path={product.allGear[22].url} component={WomensUALongSleeve} />
					<Route exact path={product.allGear[23].url} component={WomensUAZipPullover} />
					<ScrollToTop />
					<Footer />
				</React.Fragment>
			</Switch>
		</Router>
	);
};

export default App;
